import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const stages = [{
  name: 'Initial',
  tone: INK.blue,
  segments: ['VCs', 'Family offices', 'CVCs', 'Accelerators'],
  note: 'Proven today'
}, {
  name: 'Enterprise expansion',
  tone: INK.emerald,
  segments: ['Corporate innovation', 'Technology diligence', 'Procurement', 'Research'],
  note: 'Same platform, new workflows'
}];
const channels = ['Direct enterprise sales', 'Network distribution', 'Raiseboards & ecosystem communities', 'Partners', 'Data / API integrations', 'Industry networks'];
const evidence = [{
  value: '$100K',
  label: 'Sony Innovation Fund engagement'
}, {
  value: '7',
  label: 'Raiseboards live'
}, {
  value: '36',
  label: 'Companies added to Raiseboards'
}];
export function GoToMarketSlide() {
  return <Slide data-id="element-111" data-mp="1068zqvre86zk">
      <Eyebrow data-id="element-112" data-mp="106isus7qiu9h">Go-to-market</Eyebrow>
      <Title className="mt-[2.2cqh]" data-id="element-113" data-mp="107ketrqah15z">Land with investors. Expand into enterprise.</Title>

      <div className="mt-auto flex items-stretch gap-[1.4cqw]" data-id="element-114" data-mp="148vwnb2x8i3m">
        {stages.map((s, i) => <React.Fragment key={s.name} data-id="element-115" data-mp="195w2bkvuziu7" data-mpi={i}>
            {i > 0 && <span className="self-center text-[1.8cqw] text-white/30" aria-hidden data-id="element-116" data-mp="1e5qtzqngkcgb">
                →
              </span>}
            <Reveal delay={0.06 * i} className="flex-1 border border-white/10 bg-white/[0.025] p-[1.8cqw]" data-id="element-117" data-mp="1j420psigi6ub">
              <div className="flex items-baseline justify-between" data-id="element-118" data-mp="1n5dtu80jha79">
                <Label tone={s.tone} data-id="element-119" data-mp="1rwx2udcmnmfv">{s.name}</Label>
                <Label data-id="element-120" data-mp="1rzi4b190k0d3">{s.note}</Label>
              </div>
              <div className="mt-[2.2cqh] grid grid-cols-2 gap-x-[1.6cqw]" data-id="element-121" data-mp="1wvgm25zu6k4j">
                {s.segments.map(seg => <p key={seg} className="border-b border-white/8 py-[1.4cqh] text-[1.4cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-122" data-mp="21x62601x1nzh">
                    {seg}
                  </p>)}
              </div>
            </Reveal>
          </React.Fragment>)}
      </div>

      <Reveal delay={0.2} className="mt-[3cqh]" data-id="element-123" data-mp="1c8s4ow8ssc3n">
        <Label tone={INK.violet} data-id="element-124" data-mp="1qwd9culbmjdo">Channels</Label>
        <div className="mt-[1.6cqh] grid grid-cols-6 gap-[0.8cqw]" data-id="element-125" data-mp="1qx55c6ityj4h">
          {channels.map(c => <span key={c} className="border border-white/12 px-[0.9cqw] py-[1.6cqh] text-[0.98cqw] leading-snug text-[#DCE3EE]" data-id="element-126" data-mp="1m42a7tyen1m6">
              {c}
            </span>)}
        </div>
      </Reveal>

      <Reveal delay={0.3} className="mt-[3cqh] grid grid-cols-3 border-t border-white/12 pt-[2.2cqh]" data-id="element-127" data-mp="1uxfe1qy0bnn1">
        {evidence.map((e, i) => <div key={e.label} className={i === 0 ? '' : 'border-l border-white/10 pl-[1.4cqw]'} data-id="element-128" data-mp="24we9g7trhms3" data-mpi={i}>
            <p className="text-[2cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-129" data-mp="fh6npe9l6orn">
              {e.value}
            </p>
            <div className="mt-[0.9cqh]" data-id="element-130" data-mp="aivglbaoesd4">
              <Label data-id="element-131" data-mp="ajy4rbgm6gpc">{e.label}</Label>
            </div>
          </div>)}
      </Reveal>
    </Slide>;
}